import Section from "../../components/base/Section.jsx";
import Input from "../../components/base/Input.jsx";
import Radio from "../../components/base/Radio.jsx";
import PhoneInput from "../../components/base/PhoneInput.jsx";
import { theme } from "../../theme.js";

export default function Step1({ formData, setFormData, getUserData, cleanUserData, isReadOnly = false }) {

  return (
    <>
      {/* Type de participant */}
      {!isReadOnly && (
      <Section title="">
        <div style={styles.buttonGroupContainer}>
          <button
            onClick={getUserData}
            style={{
              ...styles.participantButton,
              ...(formData.participantType === "self" ? styles.participantButtonActive : {}),
            }}
          >
            🏃 Moi-même
          </button>
          <button
            onClick={cleanUserData}
            style={{
              ...styles.participantButton,
              ...(formData.participantType === "other" ? styles.participantButtonActive : {}),
            }}
          >
            👤 Une autre personne
          </button>
        </div>
      </Section>
      )}

      {/* Informations personnelles */}
      <Section title="INFORMATIONS PERSONNELLES">
        <Input
          name="firstname"
          label="Prénom"
          value={formData.firstname}
          setFormData={setFormData}
          type="text"
          required
          disabled={isReadOnly}
        />
        <Input
          name="lastname"
          label="Nom"
          value={formData.lastname}
          setFormData={setFormData}
          type="text"
          required
          disabled={isReadOnly}
        />
        <Radio
          choice={{ 
            name: "gender", 
            label: "Genre", 
            choices: [
              { value: "M", label: "Male" },
              { value: "F", label: "Female" },
              { value: "O", label: "Other" }
            ] 
          }}
          formData={formData}
          setFormData={setFormData}
          required
          disabled={isReadOnly}
        />

        <Input
            value={formData.birthdate}
            setFormData={setFormData}
            name="birthdate"
            label="Date de naissance"
            type="date"
            required
            disabled={isReadOnly}
        />
      </Section>
      <Section title="CONTACT">
        <Input
          name="email"
          label="Email"
          value={formData.email}
          setFormData={setFormData}
          type="email"
          required
          disabled={isReadOnly}
        />
        <PhoneInput 
            name="phone"
            label="Téléphone"
            phoneValue={formData.phone}
            setFormData={setFormData}
            required
            disabled={isReadOnly}
        />
      </Section>
    </>
  );
}

const styles = {
  buttonContainer: {
    display: "flex",
    gap: theme.spacing.md,
    marginTop: theme.spacing.lg,
    marginBottom: theme.spacing.lg,
  },
  buttonGroupContainer: {
    display: "flex",
    gap: theme.spacing.md,
    marginBottom: theme.spacing.lg,
    width: "100%",
  },
  participantButton: {
    flex: "1",
    padding: `${theme.spacing.md} ${theme.spacing.lg}`,
    fontSize: theme.fonts.size.md,
    fontWeight: theme.fonts.weight.medium,
    border: `2px solid ${theme.colors.border}`,
    borderRadius: theme.radius.lg,
    backgroundColor: theme.colors.bgLight,
    color: theme.colors.textInverted,
    cursor: "pointer",
    transition: theme.transitions.base,
    width: "49%",
  },
  participantButtonActive: {
    backgroundColor: theme.colors.bgDark,
    color: theme.colors.white,
    borderColor: theme.colors.light,
  },
};
